import Logo from '../logos/sbcsim';

export default Logo;
